// src/components/ui/Snowfall.jsx
import React from "react";

export default function Snowfall({
  count = 40,
  minSize = 6,
  maxSize = 16,
  minDuration = 6,
  maxDuration = 15,
  className = ""
}) {
  return (
    <div className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}>
      {[...Array(count)].map((_, i) => {
        const size = minSize + Math.random() * (maxSize - minSize);
        const left = Math.random() * 100;
        const delay = Math.random() * 8;
        const duration = minDuration + Math.random() * (maxDuration - minDuration);
        const rotate = Math.random() * 360;

        // ❄ Random negative height so flakes START above screen
        const startY = -Math.random() * 40; // between -0vh and -40vh

        return (
          <span
            key={i}
            className="absolute text-white opacity-80"
            style={{
              left: `${left}%`,
              top: `${startY}vh`,
              fontSize: `${size}px`,
              transform: `rotate(${rotate}deg)`,
              animation: `snowFall ${duration}s linear ${delay}s infinite`,
            }}
          >
            ❄
          </span>
        );
      })}
    </div>
  );
}
